/* =====================================================================
   SERGIO SCALI -- Duetto Black
   Behaviour for sections/duetto-black.liquid: the model dropdown's price,
   the fit-check popup, the photograph sequence and the position rail.
   Loaded by that section with
   <script src="{{ 'duetto-black.js' | asset_url }}" defer></script>.

   Split out of the section for the same reason as the CSS -- see the header of
   duetto-black.css.

   `defer` matters: this used to be an inline <script> that ran the moment it
   was parsed, immediately after the markup above it. Deferred, it runs once
   the document is parsed, which is strictly safer for everything it does --
   it measures layout and reads .db-wrap's classes, all of which want a
   complete DOM. It takes the LAST .db-wrap on the page, which is the same
   element the inline version resolved to.
   ===================================================================== */

(function () {
  var all = document.querySelectorAll('.db-wrap');
  var wrap = all[all.length - 1];
  if (!wrap) return;

  /* the fit-check help popup */
  var help = wrap.querySelector('[data-db-help]');
  if (help) {
    var openers = wrap.querySelectorAll('[data-db-help-open]');
    var closer  = help.querySelector('[data-db-help-close]');
    var lastFocus = null;

    function openHelp(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      help.hidden = false;
      help.classList.add('is-open');
      if (closer) closer.focus();
    }
    function closeHelp(e) {
      if (e) e.preventDefault();
      help.classList.remove('is-open');
      help.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    Array.prototype.forEach.call(openers, function (b) {
      b.addEventListener('click', openHelp);
    });
    if (closer) closer.addEventListener('click', closeHelp);
    /* clicking the dark scrim closes it, clicking the white panel does not */
    help.addEventListener('click', function (e) { if (e.target === help) closeHelp(e); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && help.classList.contains('is-open')) closeHelp();
    });
  }

  /* price follows the dropdown */
  var sel = wrap.querySelector('.db-select');
  var price = wrap.querySelector('[data-db-price]');
  if (sel && price) {
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      if (o && o.getAttribute('data-price')) price.textContent = o.getAttribute('data-price');
    });
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var shots = Array.prototype.slice.call(wrap.querySelectorAll('.db-shot'));
  var rail = Array.prototype.slice.call(wrap.querySelectorAll('.db-dot'));

  /* Clicking a dash goes to that photograph.

     With the scroll sequence on, the shot showing is a function of how far the
     page has scrolled through the section, so "go to photo i" means "scroll to
     the point where photo i is showing" -- there is no state to set. That keeps
     click and scroll in agreement by construction instead of having to sync two
     sources of truth.

     Wired before the db-pinning check below on purpose, so the dashes still
     work when the scroll sequence is switched off, where the photographs are
     simply stacked and this scrolls to the right one. */
  var frame = wrap.querySelector('.db-frame');

  /* Is the phone carousel the live layout? Matches the CSS: the sideways
     scroller exists under 821px and is turned off for reduced motion. */
  function carousel() {
    return !!frame && !reduce && window.innerWidth <= 820;
  }
  function stepWidth() {
    if (!frame) return 0;
    var gap = parseFloat(getComputedStyle(frame).columnGap);
    if (isNaN(gap)) gap = 0;
    return frame.clientWidth + gap;
  }

  /* One place that says which dash is lit, used by the scroll sequence on
     desktop and by the carousel on a phone -- two callers, one source of
     truth, so they cannot disagree. */
  function setActive(i) {
    for (var k = 0; k < rail.length; k++) {
      /* classList, not className -- the dots carry .db-dot, which a className
         assignment would wipe along with the styling. */
      rail[k].classList.toggle('is-on', k === i);
      if (k === i) { rail[k].setAttribute('aria-current', 'true'); }
      else { rail[k].removeAttribute('aria-current'); }
    }
  }

  /* Clicking a dash goes to that photograph.

     Three layouts, three meanings of "go there": the phone carousel scrolls
     the strip sideways; the desktop scroll sequence scrolls the PAGE to the
     point where that photograph is showing (the shot on screen is a function
     of scroll position, so there is no state to set and click and scroll agree
     by construction); a plain stack just scrolls the figure into view.

     Wired before the db-pinning check below on purpose, so the dashes work
     with the scroll sequence switched off too. */
  function goTo(i) {
    if (!shots[i]) return;
    if (carousel()) {
      var step = stepWidth();
      if (step > 0) frame.scrollTo({ left: i * step, behavior: 'smooth' });
      setActive(i);
      return;
    }
    if (reduce || window.innerWidth <= 820 || !wrap.classList.contains('db-pinning')) {
      shots[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
      setActive(i);
      return;
    }
    var travel = wrap.offsetHeight - window.innerHeight;
    if (travel <= 0 || shots.length < 2) return;
    var top = wrap.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: top + (i / (shots.length - 1)) * travel, behavior: 'smooth' });
  }
  rail.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.getAttribute('data-db-go'), 10) || 0);
    });
  });

  /* Swiping updates the dashes. Throttled through requestAnimationFrame
     because a touch scroll fires this continuously. */
  if (frame) {
    var cTick = false;
    frame.addEventListener('scroll', function () {
      if (cTick || !carousel()) return;
      cTick = true;
      window.requestAnimationFrame(function () {
        cTick = false;
        var step = stepWidth();
        if (step > 0) setActive(Math.round(frame.scrollLeft / step));
      });
    }, { passive: true });
  }

  /* photographs advance with the scroll, desktop only */
  if (!wrap.classList.contains('db-pinning')) return;
  if (shots.length < 2) return;

  /* How much scroll runway the photo sequence gets.

     SPLIT layout: none is added. The panel's own content (price, selectors,
     button, love rotator, accordions, Pair With) is already taller than the
     screen, and the photograph column is sticky beside it, so the sequence is
     mapped onto the panel's natural scroll distance. Forcing a height here --
     which is what this function used to do unconditionally, one screen per
     photograph -- made the wrap 400vh tall and clipped the panel to the first
     screen, putting everything below the rotator out of reach.

     STACKED layout: the photograph is not sticky and has nothing tall beside
     it, so it still needs an explicit runway, one screen per photograph.

     Returning true means "there is travel to paint across"; paint() works off
     wrap.offsetHeight either way, so it needs no changes. */
  function height() {
    var split = wrap.classList.contains('db-lay-split');
    if (reduce || window.innerWidth <= 820) { wrap.style.height = ''; return false; }
    if (split) {
      wrap.style.height = '';
      /* travel exists only if the panel actually overflows the screen */
      return wrap.offsetHeight - window.innerHeight > 40;
    }
    wrap.style.height = (shots.length * 100) + 'vh';
    return true;
  }

  var last = -1, ticking = false;
  function paint() {
    ticking = false;
    if (reduce || window.innerWidth <= 820) return;
    var r = wrap.getBoundingClientRect();
    var travel = wrap.offsetHeight - window.innerHeight;
    if (travel <= 0) return;
    var p = Math.min(1, Math.max(0, (-r.top) / travel));
    var pos = p * (shots.length - 1);
    for (var i = 0; i < shots.length; i++) {
      var d = Math.abs(pos - i);
      shots[i].style.opacity = d >= 1 ? 0 : 1 - d;
      shots[i].style.transform = 'scale(' + (1 + 0.03 * Math.min(d, 1)) + ')';
    }
    var idx = Math.round(pos);
    if (idx !== last) { last = idx; setActive(idx); }
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(paint); } }
  function reset() {
    if (!height()) { shots.forEach(function (s) { s.style.opacity = ''; s.style.transform = ''; }); last = -1; }
    else { paint(); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', reset);
  reset();
})();
